if (document.querySelector('.logosSwiper')) {
    var swiper = new Swiper('.logosSwiper', {
        speed: 700,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        spaceBetween: 16,
        slidesPerView: 2,
        breakpoints: {
            768: {
                spaceBetween: 32,
                slidesPerView: 4,
            },
            1024: {
                spaceBetween: 64,
                slidesPerView: 6,
            },
            1440: {
                spaceBetweean: 96,
                slidesPerView: 7,
            },
        },
    });
}
